<template>
  <transition name="modal">
    <div id="clipper">
      <div class="msgBox">
        <div class="mask" @click="cancel"></div>
        <!-- <div class="mask" @click="dismiss($event)"></div> -->
        <div class="message">
          <div class="clip-title">
            {{ getString("clipper.title") }}
            <div class="closeBtn"><v-icon @click="cancel">close</v-icon></div>
          </div>
          <clipper-fixed
            class="my-clipper custom"
            ref="clipper"
            :src="image"
            :ratio="ratio"
            :wrapRatio="ratio"
            :area="area"
          ></clipper-fixed>
          <div class="zoomBtn">
            <div class="zoom more" @click="zoomIn"><span>+</span></div>
            <div class="zoom less" @click="zoomOut"><span>-</span></div>
          </div>
          <div class="footerBtn">
            <div class="btn secondary" @click="cancel">{{ $t("cancel") }}</div>
            <div class="btn primary" @click="save">{{ $t("confirm") }}</div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import i18n from '@/i18n'
export default {
  props: {
    image: String,
    ratio: String,
    area: Number
  },
  data () {
    return {
      zoom: 1
    }
  },
  created () {},
  computed: {},
  methods: {
    save () {
      // const canvas = this.$refs.clipper.clip();
      // var image = canvas.toDataURL("image/jpg");
      const canvas = this.$refs.clipper.clip({ wPixel: 2000 }) // call component's clip method
      var resizedCanvas = document.createElement('canvas')
      var resizedContext = resizedCanvas.getContext('2d')
      if (+this.ratio === 1) {
        resizedCanvas.height = '500'
        resizedCanvas.width = '500'
      } else {
        resizedCanvas.height = '1123'
        resizedCanvas.width = '2000'
      }
      canvas.getContext('2d')
      resizedContext.drawImage(
        canvas,
        0,
        0,
        resizedCanvas.width,
        resizedCanvas.height
      )
      var image = resizedCanvas.toDataURL('image/webp', 0.7) // canvas->image

      this.$emit('getImage', image)
    },
    cancel () {
      this.$emit('getImage', false)
    },
    zoomIn () {
      this.zoom += 0.1
      this.$refs.clipper.setWH$.next(this.zoom)
    },
    zoomOut () {
      this.zoom -= 0.1
      this.$refs.clipper.setWH$.next(this.zoom)
    },

    getString (str) {
      return i18n.t(str)
    },
    getStringPlural (str, pos) {
      return i18n.tc(str, pos)
    }
  },
  mounted () {}
}
</script>

<style lang="scss">
#clipper {
  .msgBox {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    -webkit-transition: opacity 0.3s ease;
    -moz-transition: opacity 0.3s ease;
    transition: opacity 0.3s ease;
    z-index: 9999;
  }

  .clip-title {
    position: relative;
    font-size: 20px;
    padding: 9px 12px 0px 12px;
    background: #fff;
  }

  .closeBtn {
    position: absolute;
    top: 20px;
    right: 10px;
    transform: translateY(-50%);
    text-align: center;
    font-size: 18px;
    z-index: 999;
    cursor: pointer;
  }

  .zoomBtn {
    position: absolute;
    top: 50px;
    right: 10px;

    .zoom {
      text-align: center;
      margin: 10px;
      width: 50px;
      height: 50px;
      border-radius: 100%;
      background-color: #222;

      cursor: pointer;
      &:hover {
        background-color: $main_color;
        transition: 0.2s;
      }
      span {
        line-height: 50px;
        font-size: 33px;
        color: #fff;
      }
    }
  }

  .footerBtn {
    display: inline-block;
    position: relative;
    margin: 0;
    margin-top: 20px;
    padding: 0 0;
    line-height: 1.15;
    height: 50px;
    border: none;
    background-color: #fff;
    color: rgba(0, 0, 0, 0.65);
    font-weight: 500;
    text-align: center;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    cursor: pointer;
    white-space: nowrap;
    -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 100%;
    font-size: 22px;
    position: absolute;
    bottom: 0;
    left: 0;

    .btn {
      border: none;
      height: 50px;
      width: 50%;
      float: left;
      line-height: 50px;
      text-align: center;
      font-size: 18px;

      &.primary {
        background-color: #222 !important;
        color: #fff !important;
      }
      &.secondary {
        background-color: #ccc !important;
      }
    }
  }

  .mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
  }

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }
  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
  .my-clipper {
    // No quitar esta clase (si no está ignora a la siguiente ¿¿???)
  }
  .custom {
    padding: 12px;
    width: 100%;
    margin: 0 auto;
    margin-bottom: 70px;
    overflow: hidden;
    height: calc(100% - 100px);

    .wrap {
      max-height: 500px !important;
      height: auto !important;
    }
  }

  .message {
    /* margin: 10px 0px; */
    padding: 0 0 !important;
    text-align: left;
    padding-left: 40px;
    font-size: 10pt;
    width: 50%;
    height: auto;
    max-height: 80%;
    margin: 5% auto;
    background-color: #fff;
    position: relative;
    position: relative;
    overflow: hidden;
  }

  // .cover .area {
  //   width: 95% !important;
  // }

  @include media(">phone", "<tablet") {
    .message {
      width: 100%;
    }
  }
}
</style>
